import React from 'react';
import { Breadcrumb } from '../components/common/Breadcrumb';
import { UserIcon, BellIcon, ShieldIcon, PaletteIcon, GlobeIcon, KeyIcon } from 'lucide-react';
const breadcrumbItems = [{
  label: 'Sistema',
  href: '#'
}, {
  label: 'Configuración'
}];
export const Settings = () => {
  return <div className="min-h-screen bg-gray-50" data-id="element-1485">
      <main className="pt-16 pl-64" data-id="element-1486">
        <div className="max-w-7xl mx-auto p-8" data-id="element-1487">
          <div className="mb-8" data-id="element-1488">
            <Breadcrumb items={breadcrumbItems} data-id="element-1489" />
            <h1 className="text-2xl font-bold text-gray-900 mt-4" data-id="element-1490">
              Configuración y Perfil
            </h1>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1491">
            {/* Profile Section */}
            <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-1492">
              <div className="flex items-center gap-4 mb-6" data-id="element-1493">
                <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Profile" className="h-16 w-16 rounded-full" data-id="element-1494" />
                <div data-id="element-1495">
                  <h2 className="text-xl font-semibold text-gray-900" data-id="element-1496">
                    John Doe
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-1497">john.doe@simfin.com</p>
                </div>
              </div>
              <div className="space-y-4" data-id="element-1498">
                <button className="w-full flex items-center gap-3 p-3 text-left text-gray-700 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-1499">
                  <UserIcon className="h-5 w-5 text-gray-400" data-id="element-1500" />
                  <div data-id="element-1501">
                    <div className="font-medium" data-id="element-1502">Información Personal</div>
                    <div className="text-sm text-gray-500" data-id="element-1503">
                      Actualiza tu información de perfil
                    </div>
                  </div>
                </button>
                <button className="w-full flex items-center gap-3 p-3 text-left text-gray-700 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-1504">
                  <BellIcon className="h-5 w-5 text-gray-400" data-id="element-1505" />
                  <div data-id="element-1506">
                    <div className="font-medium" data-id="element-1507">Notificaciones</div>
                    <div className="text-sm text-gray-500" data-id="element-1508">
                      Gestiona tus preferencias de notificación
                    </div>
                  </div>
                </button>
                <button className="w-full flex items-center gap-3 p-3 text-left text-gray-700 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-1509">
                  <KeyIcon className="h-5 w-5 text-gray-400" data-id="element-1510" />
                  <div data-id="element-1511">
                    <div className="font-medium" data-id="element-1512">Contraseña y Seguridad</div>
                    <div className="text-sm text-gray-500" data-id="element-1513">
                      Actualiza tu contraseña
                    </div>
                  </div>
                </button>
              </div>
            </div>
            {/* System Settings */}
            <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-1514">
              <h2 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-1515">
                Configuración del Sistema
              </h2>
              <div className="space-y-4" data-id="element-1516">
                <button className="w-full flex items-center gap-3 p-3 text-left text-gray-700 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-1517">
                  <ShieldIcon className="h-5 w-5 text-gray-400" data-id="element-1518" />
                  <div data-id="element-1519">
                    <div className="font-medium" data-id="element-1520">Seguridad</div>
                    <div className="text-sm text-gray-500" data-id="element-1521">
                      Configuración de seguridad y acceso
                    </div>
                  </div>
                </button>
                <button className="w-full flex items-center gap-3 p-3 text-left text-gray-700 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-1522">
                  <PaletteIcon className="h-5 w-5 text-gray-400" data-id="element-1523" />
                  <div data-id="element-1524">
                    <div className="font-medium" data-id="element-1525">Apariencia</div>
                    <div className="text-sm text-gray-500" data-id="element-1526">
                      Personaliza la interfaz
                    </div>
                  </div>
                </button>
                <button className="w-full flex items-center gap-3 p-3 text-left text-gray-700 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-1527">
                  <GlobeIcon className="h-5 w-5 text-gray-400" data-id="element-1528" />
                  <div data-id="element-1529">
                    <div className="font-medium" data-id="element-1530">Idioma y Región</div>
                    <div className="text-sm text-gray-500" data-id="element-1531">
                      Configura el idioma y formato regional
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};